export const ADMIN_GROUP_NAME = 'Admins';

export const hasAdminGroup = (groups?: string[]) =>
  Array.isArray(groups) && groups.includes(ADMIN_GROUP_NAME);
